export const APP_VERSION = {
  commit: __APP_COMMIT__,
  build: __APP_BUILD__,
  builtAt: __APP_BUILD_TIME__,
  release: __APP_RELEASE__,
};

export const IS_DEV_BUILD = APP_VERSION.commit === "dev";
